import React, { useState, lazy, useEffect, Suspense } from "react";
/* import SliderV1 from '../slider/SliderV1'; */
import BoxNavigation from "../box_button/BoxButtonNavigation.js";
import HomeScrollGames from "../scroll/home_scroll_games.js";
import ProviderList from "../scroll/provider_scroll.js";
import PromotionSection from "../scroll/promotion_scroll.js";
import BestWinsSlider from "../slider/best_win_slider.js";
import JackPot from "./casino/jackpot.js";

import { useTranslation } from "react-i18next";

import SearchBox from "./casino/searchbox.js";

import ModalLogin from "../modal/modal_login.js";

import NoResult from "./casino/noresult.js";

import SearchResult from "./casino/search_result.js";

import ProviderListCasino from "./casino/provider_list.js";

import LoadCategory from "./casino/LoadCategory.js";
import ModalGame from "../modal/modal_game.js";

import MobileNavigation from "../footer/navigation_bar_bottom.js";

import GameWeek from "../footer/navigation_bar_bottom.js";

import Game from "../../../class/Game/Game";
import Games from "../../../class/Game_copy/Game";

import LOAD_GAMES_BY_PROVIDER_ID from "../modal/load_games_by_provider_id";
import LOAD_GAMES_BY_SUBCATEGORY from "../modal/load_games_by_subcategory.js";

const SearchModal = lazy(() => import("../modal/modal_search.js"));

const Casino = ({
    isLogged,
    setIsLogged,
    AuthService,
    UserService,
    category,
    onNavigationChange,
    activePage,
    lang,
    casinoSections,
    setIsLoginModalOpen,
}) => {
    const { t } = useTranslation();

    const [showGamesModalSingleProvider, setshowGamesModalSingleProvider] =
        useState(false);
    const [selectedProvider, setSelectedProvider] = useState(null);

    const [
        showGamesModalSingleSubcategory,
        setshowGamesModalSingleSubcategory,
    ] = useState(false);
    const [selectedSubcategory, setSelectedSubcategory] = useState(null);
    const [selectedCategory, setSelectedcategory] = useState(null);
    const [selectedTagName, setSelectedTagName] = useState(null);

    const closeGamesModal = () => {
        setSelectedProvider(null);
        setshowGamesModalSingleProvider(false);
    };

    const openSingleProviderModal = (provider) => {
        setSelectedProvider(provider);
        setshowGamesModalSingleProvider(true);
    };

    const closeSubcategoryModal = () => {
        setSelectedcategory(null);
        setSelectedSubcategory(null);
        setshowGamesModalSingleSubcategory(false);
    };

    const openSingleSubcategoryModal = (category, subcategory, tagName) => {
        setSelectedcategory(category);
        setSelectedSubcategory(subcategory);
        setSelectedTagName(tagName);

        setshowGamesModalSingleSubcategory(true);
    };

    const [showSearchModal, setShowSearchModal] = useState(false);

    const handleOpenSearchModal = () => setShowSearchModal(true);
    const handleCloseSearchModal = () => setShowSearchModal(false);

    return (
        <>
            {!casinoSections[activePage] ? (
                <>
                    {["casino"].includes(category) && isLogged && (
                        <JackPot
                            selection="casino"
                            AuthService={AuthService}
                            UserService={UserService}
                        />
                    )}

                    <div className="container-fluid account-total-game">
                        <div className="row">
                            <div className="col-2 side_bar_navigation_casino">
                                <MobileNavigation
                                    isLogged={isLogged}
                                    onNavigationChange={onNavigationChange}
                                    activePage={activePage}
                                    openSingleProviderModal={
                                        openSingleProviderModal
                                    }
                                    handleOpenSearchModal={
                                        handleOpenSearchModal
                                    }
                                    casinoSections={casinoSections}
                                    openSingleSubcategoryModal={
                                        openSingleSubcategoryModal
                                    }
                                />
                            </div>

                            <div className="col-10 content-game">
                                {/* <SliderV1 sliderType="Casino" isLogged={isLogged} lang={lang} handleOpenRegisterModal={handleOpenRegisterModal}/> */}

                                {["crash-game"].includes(category) ? (
                                    <LoadCategory
                                        category="crash-game"
                                        limit={30}
                                        page={1}
                                        AuthService={AuthService}
                                        isLogged={isLogged}
                                        setIsLoginModalOpen={
                                            setIsLoginModalOpen
                                        }
                                    />
                                ) : (
                                    <ProviderListCasino
                                        game_slugs={["casino"]}
                                        limit="4"
                                        AuthService={AuthService}
                                        UserService={UserService}
                                        category={category}
                                        isLogged={isLogged}
                                        setIsLoginModalOpen={
                                            setIsLoginModalOpen
                                        }
                                    />
                                )}

                                <BestWinsSlider selection={category} />
                            </div>
                            <div />
                        </div>
                    </div>

                    {showGamesModalSingleProvider && selectedProvider && (
                        <LOAD_GAMES_BY_PROVIDER_ID
                            Game={Games}
                            AuthService={AuthService}
                            user_id={AuthService.getCustom("user_id") || ""}
                            provider_id={selectedProvider?.id}
                            category_id={selectedProvider?.category_id}
                            provider_name={selectedProvider?.name}
                            provider_slug={selectedProvider?.slug}
                            onClose={closeGamesModal}
                            isLogged={isLogged}
                            setIsLoginModalOpen={setIsLoginModalOpen}
                        />
                    )}

                    {showGamesModalSingleSubcategory &&
                        selectedSubcategory &&
                        selectedCategory &&
                        selectedTagName && (
                            <LOAD_GAMES_BY_SUBCATEGORY
                                Game={Games}
                                AuthService={AuthService}
                                user_id={AuthService.getCustom("user_id") || ""}
                                subcategory_slug={selectedSubcategory}
                                category_slug={selectedCategory}
                                tag_name={selectedTagName}
                                onClose={closeSubcategoryModal}
                                isLogged={isLogged}
                                setIsLoginModalOpen={setIsLoginModalOpen}
                            />
                        )}

                    <Suspense fallback={<div>{t("loading")}...</div>}>
                        {showSearchModal && (
                            <SearchModal
                                show={showSearchModal}
                                handleClose={handleCloseSearchModal}
                                casinoSections={casinoSections}
                                AuthService={AuthService}
                                isLogged={isLogged}
                            />
                        )}
                    </Suspense>
                </>
            ) : (
                <NoResult />
            )}
        </>
    );
};

export default Casino;
